import { usePathname } from "@/hooks/use-pathname-compat";
import { useSearchParams } from "@/hooks/use-search-params-compat";
import { usePostHog } from "posthog-js/react";
import { useEffect, Suspense } from "react";

function PostHogPageViewInternal() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();

  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname;
      if (searchParams && searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }
      posthog.capture("$pageview", {
        $current_url: url,
      });
    }
  }, [pathname, searchParams, posthog]);

  return null;
}

export function PostHogPageView() {
  return (
    <Suspense fallback={null}>
      <PostHogPageViewInternal />
    </Suspense>
  );
}
